__turbopack_context__.v({
  "back": "flipperCard-module-scss-module__7ouoJa__back",
  "flipContainer": "flipperCard-module-scss-module__7ouoJa__flipContainer",
  "flipped": "flipperCard-module-scss-module__7ouoJa__flipped",
  "flipper": "flipperCard-module-scss-module__7ouoJa__flipper",
  "front": "flipperCard-module-scss-module__7ouoJa__front",
});
